<template>
  <div>
    <van-nav-bar :title="name" left-arrow fixed class="jump-nav-bar" @click-left="back" />
<!-- 聊天 对话框的样式 -->
    <div class="item" >
      <!-- 提问 -->
      <div class="sendBox">
        <div class="cont">
          <div class="avator">
            <img src="../../assets/avatar.png" />
          </div>
          <div class="send">
            <div class="arrow"></div>
            {{content}}
          </div>
        </div>
      </div>
      <!-- 回复 -->
      <div class="replayBox" v-if="consult_content!=''">
        <div class="cont">
          <div class="avator">
            <img src="../../assets/avatar.png" />
          </div>
          <div class="replay">
            <div class="arrow"></div>
            {{consult_content}}
          </div>
        </div>
      </div>
    </div>
    <div class="foot" v-if="userRole.indexOf('BUYER')<0">
      <van-field v-model="replayCont" placeholder="请输入消息" rows="1"
  autosize
  type="textarea">
        <template #button>
          <van-button size="small" type="primary"  @click="handleSave">发送</van-button>
        </template>
      </van-field>
    </div>
  </div>
</template>

<script>
import { NavBar, Row, Col, Tab, Tabs, Button, List, Field } from "vant";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [Field.name]: Field,
    [List.name]: List
  },
  data() {
    return {
      name: this.$route.query.typeName,
      content:this.$route.query.wen,//提问的内容
      consult_content:'',//回复的内容
      replayCont: "",//发送的输入框里的内容
      id:this.$route.query.id,
      total: 0,
      isReply:false,
      userRole: localStorage.getItem("userRole"),
      lookId:this.$route.query.lookId,
    };
  },
  mounted(){
   if(this.$route.query.cont!=''){
      this.consult_content=this.$route.query.cont;
     // this.replayCont=this.consult_content;
   }else{
     this.consult_content='';
   }
   this.changeStauts();
  },
  methods: {
    changeStauts (){
      this.$api.post(
                    this.jumuc.userCenter.lookMessages,
                    {
                        "messageId": this.lookId
                    },
                    successRes => {
                       
                    })
    },
    back() {
      history.go(-1);
    },
    handleSave (){//发送
      this.$api.post(
                    this.jumuc.userCenter.consult_reply_save,
                    { id:this.id, consult_reply:this.replayCont},
                    successRes => {
                    this.$toast(successRes.msg);
                    if (successRes.success) {
                            this.consult_content=this.replayCont;
                            this.isReply=true;
                    }else{
                        this.$toast(successRes.msg)
                    }
                    }
                );
    }
  }
};
</script>

<style lang="less" scoped>
.foot {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
// 聊天对话框的样式
.cont {
  display: flex;
  flex-direction: row;
  padding-bottom: 6px;
}
.send {
  position: relative;
  max-width: 62%;
  background: #fff;
  border-radius: 5px;
  margin-left: 10px;
  margin-top: 5px;
  color: #333;
  line-height: 22px;
  padding: 8px;
  min-height: 30px;
}
.avator {
  width: 46px;
  height: 46px;
  img {
    width: 48px;
    height: 48px;
  }
}
.send .arrow {
  position: absolute;
  top: 8px;
  left: -16px;
  width: 0;
  height: 0;
  font-size: 0;
  border: solid 8px;
  border-color: transparent #fff transparent transparent;
}
//   回复的
.replayBox {
  .cont {
    flex-direction: row;
    flex-direction: row-reverse;
  }
}
.replay {
  position: relative;
  max-width: 62%;
  background: #47d51cfc;
  border-radius: 5px;
  margin-right: 10px;
  margin-top: 5px;
  color: #333;
  line-height: 22px;
  padding: 8px;
  min-height: 30px;
  word-break:break-all;
}
.replay .arrow {
  position: absolute;
  top: 8px;
  right: -16px;
  width: 0;
  height: 0;
  font-size: 0;
  border: solid 8px;
  border-color: transparent transparent transparent #47d51cfc;
}
.status {
  font-size: 16px;
  color: #fa3407;
}
.item {
  padding: 10px;
  background: #f7f7f7;
  margin-top: 14px;
  margin-bottom: 60px;
}
.time {
  font-size: 14px;
  text-align: center;
}
</style>